// extracted by mini-css-extract-plugin
export default {"book":"ComponentForm_book__DMPEg","buttons":"ComponentForm_buttons__yNuT8"};